module.exports = __webpack_public_path__ + "static/media/mail2.715b12db.svg";